/**
 * Thin client for the `refreshbanditposterior` callable — the demand-driven
 * posterior recompute. Always fire-and-forget: the caller never depends on
 * the result (stale sampling is batched Thompson sampling, which is fine),
 * so failures are logged at debug level and swallowed.
 */

import {getFunctions, httpsCallable} from 'firebase/functions';

/**
 * Asks the backend to recompute one experiment's posterior snapshot if it is
 * stale. Safe to call redundantly: the function is a stateless recompute and
 * lease-debounces concurrent requests.
 *
 * @param options.courseId - Course run of the experiment.
 * @param options.experimentId - Experiment to refresh.
 * @return Nothing; resolves in the background, errors are logged at debug.
 */
export function requestBanditRefresh({
  courseId,
  experimentId,
}: {
  courseId: string;
  experimentId: string;
}): void {
  const callable = httpsCallable<{courseId: string; experimentId: string}, unknown>(
    getFunctions(),
    'refreshbanditposterior',
  );
  callable({courseId, experimentId}).catch(e => {
    console.debug('[bandit] refresh request failed', courseId, experimentId, e);
  });
}
